import React from 'react';

/**
 * Thin accent “paint” bars that ease down from under the info card, behind {@link InfoDripBorder}.
 * Timings / positions tuned with `.info-paint-drip-lines` in App.css.
 */
const LINES = [
  { left: '20%', delay: '0s', durationSec: 3.55, widthPx: 5, len: 'clamp(3.5rem, 15vw, 6.25rem)' },
  { left: '47%', delay: '0.14s', durationSec: 3.35, widthPx: 4, len: 'clamp(3.75rem, 16vw, 6.75rem)' },
  { left: '74%', delay: '0.28s', durationSec: 3.75, widthPx: 5.5, len: 'clamp(3.25rem, 14vw, 6rem)' },
];

export default function InfoBackgroundDripLines() {
  return (
    <div className="info-paint-drip-lines" aria-hidden="true">
      {LINES.map(({ left, delay, durationSec, widthPx, len }, i) => (
        <span
          key={i}
          className="info-paint-drip-line"
          style={{
            left,
            width: `${widthPx}px`,
            '--drip-line-delay': delay,
            '--drip-line-dur': `${durationSec}s`,
            '--drip-line-len': len,
          }}
        />
      ))}
    </div>
  );
}
